import TimeItem from "../components/TimeIndicator/TimeItem";
import { employeeTime } from "../endpoints";
import useFetch from "../hooks/useFetch";

interface TimeData {
  name: string;
  total_time: number;
}

const TimeLayout = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps, @typescript-eslint/no-unused-vars
  const { data, loading } = useFetch<TimeData>(employeeTime);

    const sortedData = data ? [...data].sort((a, b) => b.total_time - a.total_time) : [];

  return (
    <>
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Tijd laden...</span>
                ) : (
                  `Tijd`
                )}
              </h1>
            </div>
            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                "Hier een overzicht van alle geschreven tijd"
              )}
            </p>
          </div>
        </div>
        <div className="bg-white m-auto w-[80vw] h-[85vh] rounded-xl flex justify-center items-center mt-4">
          <div className="w-[90%] h-[90%] text-black flex flex-row items-center">
            {/* Display data */}
            <div className="flex flex-col w-[90%] h-[100%] overflow-y-hidden overflow-x-auto">
              {sortedData.map((item, index) => (
                <TimeItem
                  key={index}
                  name={item.name}
                  hours={item.total_time}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TimeLayout;
